import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classes from './PolicyPages.module.scss';
import Divider from '../../components/divider/Divider';

const TermsOfService = () => {
  return (
    <Row className='g-0'>
      <Col lg={1}></Col>
      <Col lg={10}>
        <div className={`${classes.tsWrapper} mb-4`}>
          <Divider className='mt-0' />
          <h1 className='themeH1'>Flitz.ai Terms of Service</h1>
          <p className={`${classes.para} my-3`}>Last updated: March 2026</p>
          <p className={`${classes.para} my-3`}>The authoritative version of these terms is published at <a href="https://flitz.ai/terms">flitz.ai/terms</a>.</p>

          <p className='dashSectionHead my-3'>1. Scope</p>
          <p className={`${classes.para} my-3`}>These Terms of Service govern your use of the Flitz.ai platform ("Service"), operated by Flitz.ai, Switzerland. By registering for an account, you agree to these terms.</p>

          <p className='dashSectionHead my-3'>2. Service Description</p>
          <p className={`${classes.para} my-3`}>Flitz.ai provides AI-powered services for Swiss businesses and individuals. The Service is designed to assist with — but not replace — professional advice.</p>

          <p className='dashSectionHead my-3'>3. Account Responsibilities</p>
          <p className={`${classes.para} my-3`}>You are responsible for maintaining the confidentiality of your account credentials, all activity under your account, the accuracy of data you upload, and ensuring your use complies with applicable Swiss law.</p>

          <p className='dashSectionHead my-3'>4. AI-Generated Content</p>
          <p className={`${classes.para} my-3`}>Content generated by our AI is provided as suggestions. You are responsible for reviewing and approving all AI-generated output. Flitz.ai does not provide tax or legal advice or replace a certified professional.</p>

          <p className='dashSectionHead my-3'>5. Data Ownership</p>
          <p className={`${classes.para} my-3`}>You retain full ownership of all data you upload or generate through the Service. We claim no intellectual property rights over your data. You may export your data at any time.</p>

          <p className='dashSectionHead my-3'>6. Pricing &amp; Payment</p>
          <p className={`${classes.para} my-3`}>Subscription prices are listed on our pricing page in Swiss Francs (CHF). Plans are billed monthly. We may change pricing with 30 days notice. Free plans may have usage limitations as described on the pricing page.</p>

          <p className='dashSectionHead my-3'>7. Termination</p>
          <p className={`${classes.para} my-3`}>You may cancel your subscription at any time. Upon cancellation, you retain access until the end of your billing period. After termination, you have 30 days to export your data before it is permanently deleted.</p>

          <p className='dashSectionHead my-3'>8. Limitation of Liability</p>
          <p className={`${classes.para} my-3`}>Flitz.ai is provided "as is" without warranties of any kind. We are not liable for errors in AI-generated output, financial losses resulting from use of the Service, or penalties arising from content generated by the Service. Our total liability is limited to the fees paid in the 12 months preceding the claim.</p>

          <p className='dashSectionHead my-3'>9. Governing Law</p>
          <p className={`${classes.para} my-3`}>These terms are governed by Swiss law. Any disputes shall be resolved by the competent courts in Switzerland.</p>
        </div>
      </Col>
      <Col lg={1}></Col>
    </Row>
  )
}

export default TermsOfService
